import {AFD,getLS} from 'devegram-javascript-util'

const baseUrl = '/xapi/User/Customer';
const moduleAjaxService = 'backend-service'

const api = {
    namespaced: true,
    state: {
        dropdownList: {}
    },
    actions: {
        async downloadVosRate(context, params) {
            let fileName = 'ffr-customer-vos-rate'
            let fileType = 'xlsx'

            const link = document.createElement('a');
            link.href = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + ":" + process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_PORT + baseUrl + '/downloadVosRate/' + params.id;
            link.setAttribute('download', fileName + '.' + fileType);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async assign(context, params) {
           
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/assign',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let page = (params.page)? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id + '?page=' + page
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    context.dispatch('[@module-name@]-state/setOpenedEntity', r.data, {root: true}).then(() => {
                        resolve(r);
                    })
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list(context, params) {
            let page = (params.page) ? params.page : 1
            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let profile_id = '&profile_id='+getLS('user').profile_id;
            let user_id = '&id='+getLS('user').id;
            
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search+ profile_id+user_id,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async listToAssign(context, params) {
            let page = (params.page) ? params.page : 1
            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let customerUserId = (params.customerUserId) ? "&customerUserId="+ params.customerUserId : ''
            let profile_id = '&profile_id='+getLS('user').profile_id;
            let user_id = '&id='+getLS('user').id;
            
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search+ profile_id+user_id + customerUserId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async refreshRates(context){
            
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/refreshRates',
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async refreshCustomerRates(context,params){
          
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/refreshIndividualRates',
                data: params
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownList (context, params = {}) {
        	let query = ''
            if (params.hasOwnProperty('valueKey')) {
                query = '?value_key=' + params.valueKey
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList' + query,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    context.state.dropdownList = r.data
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        }
    }

};

export default api
